module.exports = __webpack_public_path__ + "img/edit.744edf03.svg";